"use client";

import * as X from "@/ui";
import { useDownloadUrl } from "@/providers/onelink";



import ZapptaxLogo from "@/assets/shared-zapptax-default.svg";
import ArrowImage from "@/assets/shared-download-arrow.svg";
import BackImage from "@/assets/shared-download-back.svg";
import { useDownloadPage } from "@/providers/strapi/content/types/singleTypes/download-page";
import ReactMarkdown from "react-markdown";
import { links } from "@/ui";


/**
 * size of the generated qr code, ie. how many pixels per module width/height.
 *
 * - 4 is a bit small to scan (barely enough, scan is slower), but firs the design
 * - 5 is a bit better, but already so-so for the design
 * - 6 is ideal to scan, but the design is too small
 */
const QrCodeScale = 4;


// const data = {
//   tagline: {
//     en: <><strong>Don’t leave your VAT</strong> behind</>,
//     fr: <>La détaxe, <strong>aussi simple que votre shopping</strong></>,
//   },

//   title: {
//     en: <>Download<br /><strong>the app</strong></>,
//     fr: <>Téléchargez<br /><strong>l'application</strong></>,
//   },

//   subtitle: {
//     en: `Or simply scan the QR code with your phone to download Zapptax`,
//     fr: `Ou scannez le code avec votre téléphone pour télécharger Zapptax`,
//   },
// };


export function DownloadPage(props: X.PageProps) {
  // const tr = X.useTranslator();
  const downloadUrl = useDownloadUrl(props.locale);

  const tagline = useDownloadPage('tagline')
  return (
    <X.BaseLayout locale={props.locale}>
      <div className="px-mobile-margin py-20 xl:py-28 w-full h-svh flex flex-col justify-center-safe items-center">
        <div className="flex flex-col gap-4 xl:gap-6 items-center">
          <X.Image src={ZapptaxLogo} alt="Zapptax" className="w-[140px] xl:w-[270px] h-auto" />

          <div className="text-[24px] xl:text-[30px] [&_strong]:font-semibold max-w-[260px] xl:max-w-[350px] text-center leading-tight">
            {/* {tr(data.tagline)} */}
            <ReactMarkdown >
              {tagline}
            </ReactMarkdown>
          </div>
        </div>

        <Mobile downloadUrl={downloadUrl} locale={props.locale} />
        <Desktop downloadUrl={downloadUrl} locale={props.locale} />
      </div>
    </X.BaseLayout>
  );
}


function Mobile(props: X.PageProps<{
  downloadUrl: string;
}>) {
  // const tr = X.useTranslator();
  const title = useDownloadPage('title')
  return (
    <div className={X.clsx(X.mobileOnly(), "flex flex-col flex-1")}>
      <div className="flex-1 flex flex-col justify-center-safe gap-12">
        {/* <h1 className="text-[36px] [&_strong]:font-semibold leading-tight text-center">
          {title}
        </h1> */}
        <ReactMarkdown components={{
          p: ({ ...props }) => <h1 {...props} className="text-[36px] [&_strong]:font-semibold leading-tight text-center" />,
          h1: ({ ...props }) => <h1 {...props} className="text-[36px] [&_strong]:font-semibold leading-tight text-center" />,
          h2: ({ ...props }) => <h1 {...props} className="text-[36px] [&_strong]:font-semibold leading-tight text-center" />,
          h3: ({ ...props }) => <h1 {...props} className="text-[36px] [&_strong]:font-semibold leading-tight text-center" />,
          h4: ({ ...props }) => <h1 {...props} className="text-[36px] [&_strong]:font-semibold leading-tight text-center" />,
        }}>
          {title}
        </ReactMarkdown>

        <DownloadButtons
          locale={props.locale}
          downloadUrl={props.downloadUrl}
        />
      </div>

      <div className="h-[100px]" />
    </div>
  );
}


function Desktop(props: X.PageProps<{
  downloadUrl: string;
}>) {
  // const tr = X.useTranslator();
  const title = useDownloadPage('title');
  const message = useDownloadPage('message');

  return (
    <div className={X.clsx(X.desktopOnly("flex"), "flex-1 flex flex-col items-stretch w-[960px] h-[680px] relative mt-4")}>
      <div className="absolute flex flex-col items-center w-[223px] left-[516px] top-[118px] gap-[40px]">
        <X.QrCode scale={QrCodeScale} value={props.downloadUrl} />

        <DownloadButtons
          locale={props.locale}
          downloadUrl={props.downloadUrl}
          apple={links.download.appStore}
          google={links.download.playStore}
        // google={"https://play.google.com/store/apps/details?id=com.zapptax.zapptax&pcampaignid=web_share"}
        // apple={"https://apps.apple.com/fr/app/zapptax-la-d%C3%A9taxe-facile/id1254346990"}
        />
      </div>

      <X.Image
        src={BackImage}
        alt="Download"
        className="absolute w-[1060px] h-auto top-0 right-0 translate-x-[160px]"
      />

      <X.Image
        src={ArrowImage}
        alt="Arrow"
        className="absolute w-[128px] h-auto left-[240px] top-[300px]"
      />


      <div className="relative top-[130px] flex flex-col gap-6">
        {/* <h1 className="text-[54px] [&_strong]:font-semibold leading-[54px]">
          {tr(data.title)}
        </h1> */}

        <ReactMarkdown components={{
          p: ({ ...props }) => <h1 {...props} className="text-[54px] [&_strong]:font-semibold leading-[54px]" />,
          h1: ({ ...props }) => <h1 {...props} className="text-[54px] [&_strong]:font-semibold leading-[54px]" />,
          h2: ({ ...props }) => <h1 {...props} className="text-[54px] [&_strong]:font-semibold leading-[54px]" />,
          h3: ({ ...props }) => <h1 {...props} className="text-[54px] [&_strong]:font-semibold leading-[54px]" />,
          h4: ({ ...props }) => <h1 {...props} className="text-[54px] [&_strong]:font-semibold leading-[54px]" />,
        }}>
          {title}
        </ReactMarkdown>

        <ReactMarkdown components={{
          p: ({ ...props }) => <p {...props} className="text-[20px] font-medium leading-tight w-[240px]" />
        }}>
          {message}
        </ReactMarkdown>
        {/* <p className="text-[20px] font-medium leading-tight w-[240px]">
          {message}
          {tr(data.subtitle)}
        </p> */}
      </div>

    </div >
  );
}


function DownloadButtons(props: X.PageProps<{
  downloadUrl: string;
  google?: string;
  apple?: string
}>) {
  // const tr = X.useTranslator();
  const appStoreImage = useDownloadPage('appStoreImage');
  const playStoreImage = useDownloadPage('playStoreImage');
  return (
    <div className="flex flex-col gap-[20px] items-center relative z-50">
      <X.ExternalLink
        //  href={props.downloadUrl}
        href={props.apple ? props.apple : props.downloadUrl}
      >
        <X.Image
          // src={tr({ en: AppStoreEn, fr: AppStoreFr, zh: AppStoreEn, })}
          src={appStoreImage.url}
          width={appStoreImage.size}
          height={appStoreImage.size}
          unoptimized
          alt="App Store" className="w-[138px] h-auto" />
      </X.ExternalLink>
      <X.ExternalLink
        // href={props.downloadUrl}
        href={props.google ? props.google : props.downloadUrl}
      >
        <X.Image
          // src={tr({ en: PlayStoreEn, fr: PlayStoreFr, zh: AppStoreEn, })}
          src={playStoreImage.url}
          unoptimized
          width={appStoreImage.size}
          height={appStoreImage.size}
          alt="Play Store" className="w-[138px] h-auto" />
      </X.ExternalLink>
    </div>
  );
}
